module.exports = __webpack_public_path__ + "img/favorite-1.b521c46a.svg";